import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=04fa454f&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=04fa454f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fa454f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04fa454f')) {
      api.createRecord('04fa454f', component.options)
    } else {
      api.reload('04fa454f', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=04fa454f&scoped=true&", function () {
      api.rerender('04fa454f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25NPdww4xu75f/JS/comp/Voucher.vue"
export default component.exports